import { formatMillions } from '../ceoFormat';
import {
  FunnelCard,
  FunnelCardDetail,
  FunnelCardLabel,
  FunnelCardSubtext,
  FunnelCardValue,
  FunnelGrid,
  FunnelSuccessValue,
  FunnelWarningValue,
  OverdueHighlight,
} from './styles';

interface InflowsFunnelGridProps {
  totalBddsPlanned: number;
  totalKs2Submitted: number;
  bddsToKs3Gap: number;
  totalExpectedNetKs3: number;
  totalKs3SignedGross: number;
  totalAdvanceDeduction: number;
  totalRetentionDeduction: number;
  totalActualReceived: number;
  bddsFulfillmentPct: number;
  ks3CollectionPct: number;
  ks3AwaitingCash: number;
  overdueKs3Receivables: number;
}

export function InflowsFunnelGrid({
  totalBddsPlanned,
  totalKs2Submitted,
  bddsToKs3Gap,
  totalExpectedNetKs3,
  totalKs3SignedGross,
  totalAdvanceDeduction,
  totalRetentionDeduction,
  totalActualReceived,
  bddsFulfillmentPct,
  ks3CollectionPct,
  ks3AwaitingCash,
  overdueKs3Receivables,
}: InflowsFunnelGridProps) {
  return (
    <FunnelGrid>
      <FunnelCard>
        <FunnelCardLabel>
          1. ПЛАНИРУЕМЫЕ ПОСТУПЛЕНИЯ ПО БДДС
        </FunnelCardLabel>
        <FunnelCardValue>
          {formatMillions(totalBddsPlanned)}
        </FunnelCardValue>
        <FunnelCardSubtext>
          Предъявлено КС-2: {formatMillions(totalKs2Submitted)} · Не закрыто КС-3:{' '}
          <strong>{formatMillions(bddsToKs3Gap)}</strong>
        </FunnelCardSubtext>
      </FunnelCard>

      <FunnelCard>
        <FunnelCardLabel>
          2. ОЖИДАЕМЫЕ ПО ПОДПИСАННЫМ КС-3 (К ОПЛАТЕ)
        </FunnelCardLabel>
        <FunnelCardValue>
          {formatMillions(totalExpectedNetKs3)}
        </FunnelCardValue>
        <FunnelCardSubtext>
          Подписано КС-3 брутто: {formatMillions(totalKs3SignedGross)} (минус аванс{' '}
          {formatMillions(totalAdvanceDeduction)} и ГУ{' '}
          {formatMillions(totalRetentionDeduction)})
        </FunnelCardSubtext>
      </FunnelCard>

      <FunnelCard $accentTone="green">
        <FunnelCardLabel>
          3. ФАКТИЧЕСКИ ПОСТУПИЛИ НА Р/С
        </FunnelCardLabel>
        <FunnelSuccessValue>
          {formatMillions(totalActualReceived)}
        </FunnelSuccessValue>
        <FunnelCardDetail>
          Исполнение БДДС: <strong>{bddsFulfillmentPct.toFixed(1)}%</strong> · Сбор по
          КС-3: <strong>{ks3CollectionPct.toFixed(1)}%</strong>
        </FunnelCardDetail>
      </FunnelCard>

      <FunnelCard $accentTone="amber">
        <FunnelCardLabel>
          4. ДЕБИТОРКА ПО ПОДПИСАННЫМ КС-3 (ОЖИДАЕТ ДЕНЕГ)
        </FunnelCardLabel>
        <FunnelWarningValue>
          {formatMillions(ks3AwaitingCash)}
        </FunnelWarningValue>
        <FunnelCardDetail>
          В т.ч. просрочено Заказчиками:{' '}
          <OverdueHighlight $hasOverdue={overdueKs3Receivables > 0}>
            {formatMillions(overdueKs3Receivables)}
          </OverdueHighlight>
        </FunnelCardDetail>
      </FunnelCard>
    </FunnelGrid>
  );
}
